module.exports = __webpack_public_path__ + "img/package-type.2f3244c9.svg";